module.exports = __webpack_public_path__ + "static/media/platinum-1.1bf8279e.png";